// styles.js
import styled from "styled-components";

export const VoiceSwitcherContainer = styled.div`
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    width: 90%;
    max-width: 320px;
    transition: all 0.2s ease;
`;

export const Title = styled.h3`
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const VoiceOptionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

/* Avatar with image inside */
export const AvatarCircle = styled.div`
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: ${({ isActive }) => (isActive ? "#4a90e2" : "#f0f0f0")};
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${({ isActive }) => (isActive ? "#ffffff" : "#666666")};
    transition: all 0.2s ease;
    box-shadow: ${({ isActive }) =>
            isActive ? "0 2px 4px rgba(0, 0, 0, 0.15)" : "none"};
    flex-shrink: 0;
    overflow: hidden;
`;

export const AvatarImg = styled.img`
    width: 34px;
    height: 34px;
    object-fit: cover;
    border-radius: 50%;
`;

export const VoiceDetails = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    flex: 1;
`;

export const VoiceName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ isActive }) => (isActive ? "#4a90e2" : "#222")};
  line-height: 1.25;
`;

export const VoiceDescription = styled.span`
  font-size: 12px;
  color: #666666;
  line-height: 1.2;
  margin-top: 2px;
`;

export const Icon = styled.i`
  font-size: ${({ size }) => size || "14px"};
  margin-right: ${({ standalone }) => (standalone ? "0" : "0px")};
`;

/* Compact Sample button */
export const SampleButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: ${({ isPlaying }) => (isPlaying ? "#4a90e2" : "#f5f5f5")};
  color: ${({ isPlaying }) => (isPlaying ? "white" : "#444")};
  border: 1px solid ${({ isPlaying }) => (isPlaying ? "#3a80d2" : "#e6e6e6")};
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: auto;

  &:hover {
    background-color: ${({ isPlaying }) => (isPlaying ? "#3a80d2" : "#ececec")};
  }

  span {
    margin-left: 2px;
  }
`;

/* Voice row */
export const VoiceOption = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ isActive }) =>
    isActive ? "rgba(74, 144, 226, 0.08)" : "transparent"};
  border: 1px solid
    ${({ isActive }) => (isActive ? "rgba(74, 144, 226, 0.3)" : "transparent")};
  transition: all 0.2s;
  margin-bottom: 4px;

  &:hover {
    background-color: ${({ isActive }) =>
    isActive ? "rgba(74, 144, 226, 0.12)" : "rgba(0, 0, 0, 0.03)"};
  }
`;

/* Compact pill toggles row */
export const ToggleRow = styled.div`
  display: flex;
  gap: 10px;
  margin: 2px 0 10px;
`;

export const ToggleButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px 6px 10px;
  border-radius: 999px;
  border: 1px solid ${({ active }) => (active ? "#3a80d2" : "#e0e0e0")};
  background: ${({ active }) => (active ? "rgba(74,144,226,0.12)" : "#fafafa")};
  color: ${({ active }) => (active ? "#1f6fcf" : "#444")};
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: ${({ active }) => (active ? "rgba(74,144,226,0.18)" : "#f0f0f0")};
  }

  span {
    line-height: 1;
  }
`;

export const SettingsButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #fafafa;
  color: #555;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;

  &:hover {
    background: #f0f0f0;
    color: #222;
    border-color: #c8c8c8;
  }
`;

export const ToggleDot = styled.div`
  width: 18px;
  height: 10px;
  border-radius: 999px;
  background: ${({ active }) => (active ? "#4a90e2" : "#d6d6d6")};
  position: relative;
  transition: background 0.15s ease;
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: ${({ active }) => (active ? "10px" : "2px")};
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #fff;
    transition: left 0.15s ease;
  }
`;
